import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ControlErrorDirective } from '../../../directive/control-error.directive';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { BeneficiaryContactDetailsFormModel } from './form-group/beneficiary-contact-details-form.model';
import { RequiredLabelDirective } from '../../../directive/required-label.directive';

@Component({
  selector: 'app-form-beneficiary-contact-details',
  imports: [
    ControlErrorDirective,
    FormsModule,
    InputText,
    ReactiveFormsModule,
    RequiredLabelDirective,
  ],
  templateUrl: './form-beneficiary-contact-details.component.html',
  styleUrl: './form-beneficiary-contact-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormBeneficiaryContactDetailsComponent {
  public formGroup =
    input.required<FormGroup<BeneficiaryContactDetailsFormModel>>();
}
